var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:_vm.props.size ? ("col col-sm-" + (_vm.props.size)) : 'col col-sm'},[_c('div',{staticClass:"content-wrapper"},[(_vm.props.label)?_c('span',{staticClass:"d-block d-sm-none font-weight-bold"},[_vm._v(_vm._s(_vm.props.label)+":")]):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }